module.exports = __webpack_public_path__ + "static/media/view_claims_2.938dc545.png";